import { assertEx } from '@xylabs/sdk-js'

import { createTransactionGpc, RebillyCreateTransactionParams } from '../xy'
import { createPaymentTokenParams } from './createPaymentTokenParams'
import { ProcessPaymentParams } from './ProcessPaymentParams'
import { ProcessPaymentResult } from './ProcessPaymentResult'
import { CartItem } from 'business-logic/cart/hooks'
import { createPaymentToken, RebillyDiscount } from '../rebilly'

const cleanCartItems = (items: CartItem[]) => {
  const cleanItems: CartItem[] = []
  for (const item of items ?? []) {
    cleanItems.push({
      planId: item.planId,
      quantity: item.quantity,
    })
  }
  return cleanItems
}

const buildPayload = (
  params: ProcessPaymentParams,
  coupons: RebillyDiscount[],
  items: CartItem[],
): RebillyCreateTransactionParams => {
  return {
    billing: params.billing,
    coupons,
    customFields: params.customFields ?? {},
    customer: params.customer ?? {},
    items: items ?? {},
    sandbox: params.sandbox,
    shipping: params.shipping,
    paymentToken: params.paymentToken,
    paymentInstrument: params.paymentInstrument
  }
}

export const processPaymentGpc = async (params: ProcessPaymentParams): Promise<ProcessPaymentResult> => {
  let result: ProcessPaymentResult = {}
  const { log } = params

  log?.debug('processPayment Started')

  assertEx((params.cartInfo.items?.length ?? 0) > 0, 'Missing Items')

  try {
    if (!params.paymentToken && params.paymentInfo) {
      params.paymentToken = await createPaymentToken(createPaymentTokenParams(params))
    }

    const coupons: RebillyDiscount[] = []
    const discountCode = params.cartInfo.discountCode?.code

    if (discountCode) {
      coupons.push({ couponId: discountCode })
    }

    const items = cleanCartItems(params.cartInfo.items ?? [])
    log?.debug('cleanCartItems')
    if (params.paymentToken || params.paymentInstrument) {
      const payload = buildPayload(params, coupons, items)
      log?.debug('buildPayload')
      // THIS ALWAYS RETURNS A 200, so outer try catches never fall into the catch block when errors, multiple error checks are required
      result = await createTransactionGpc(payload)
      if (result.errors) {
        for (const error of result.errors) {
          log?.warn('createTransaction GPC', error)
        }
        log?.warn('processPayment Failed')
      }
    } else {
      throw new Error('Failed to create Payment Token')
    }
  } catch (ex) {
    log?.error('processPayment', ex)
    result = { errors: [ex as Error] }
    throw ex
  }
  log?.debug('processPayment done')
  return result
}
